module.exports = __webpack_public_path__ + "img/hwc_2.18f02377.png";